import type { NavigateFn } from '@tanstack/react-router'
import type { inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '@viastud/server/routers/index'
import { Card, CardContent } from '@viastud/ui/card'
import type { Recommendation } from '@viastud/ui/shared/task-recommendation/student-progress-overview'

import { PreviousCourse } from './previous-course'
import { UpcomingCourse } from './upcoming-course'

type RouterOutputs = inferRouterOutputs<AppRouter>
type StudentReservations = RouterOutputs['reservations']['getStudentReservations']

interface StudentCoursesCardProps {
  incomingStudentReservations: StudentReservations
  previousStudentReservations: StudentReservations
  setReservationToDeleteId: (id: number | null) => void
  setShowDeletionModal: (open: boolean) => void
  navigate: NavigateFn
  nextRecommendation?: Recommendation
  isRecommendationLoading?: boolean
}

export function StudentCoursesCard({
  incomingStudentReservations,
  previousStudentReservations,
  setReservationToDeleteId,
  setShowDeletionModal,
  navigate,
  nextRecommendation,
  isRecommendationLoading,
}: StudentCoursesCardProps) {
  return (
    <div className="space-y-6">
      <Card className="space-y-6">
        <CardContent className="space-y-6">
          <UpcomingCourse
            incomingStudentReservations={incomingStudentReservations}
            setReservationToDeleteId={setReservationToDeleteId}
            setShowDeletionModal={setShowDeletionModal}
            navigate={navigate}
            nextRecommendation={nextRecommendation}
            isRecommendationLoading={isRecommendationLoading}
          />
        </CardContent>
      </Card>
      {previousStudentReservations.length > 0 && (
        <Card className="space-y-6">
          <CardContent className="space-y-6 pt-6">
            <PreviousCourse previousStudentReservations={previousStudentReservations} />
          </CardContent>
        </Card>
      )}
    </div>
  )
}
